import { noop } from 'lodash';
import React, { Component } from 'react';
import cookies from 'js-cookie';
import PropTypes from 'prop-types';
import {
    CROSS_PAGE_ACTIONS_COOKIE,
    PREVIOUS_MONOLITH_ACTIONS_COOKIE,
} from '../constants';

export default class CrossPageActionTracker extends Component {
    static propTypes = {
        trackPreviousMonolithAction: PropTypes.func,
    }

    static defaultProps = {
        trackPreviousMonolithAction: noop,
    }

    componentDidMount() {
        // "onDomContentLoaded"
        this.maybeTrackPreviousPageAction();
        this.maybeTrackPreviousMonolithAction();
    }

    maybeTrackPreviousPageAction = () => {
        const cookie = cookies.get(CROSS_PAGE_ACTIONS_COOKIE);
        if (cookie) {
            const cookieData = JSON.parse(cookie);
            const { atn, dta } = cookieData;
            const action = this.props[atn];
            if (action) {
                action(dta);
            }
        }
        cookies.remove(CROSS_PAGE_ACTIONS_COOKIE, { path: '/' });
    };

    maybeTrackPreviousMonolithAction = () => {
        // Check for a previous action from a monolith page
        const cookie = cookies.get(PREVIOUS_MONOLITH_ACTIONS_COOKIE);
        if (cookie) {
            const cookieData = JSON.parse(cookie);
            const {
                atn: action,
                ctg: category,
                lbl: label,
                pid: pageId,
            } = cookieData;
            if (action && category) {
                this.props.trackPreviousMonolithAction({
                    action,
                    category,
                    label,
                    pageId,
                });
            }
            cookies.remove(PREVIOUS_MONOLITH_ACTIONS_COOKIE, { path: '/' });
        }
    }

    render() {
        return (
            <span data-test="previous-action-tracker" />
        );
    }
}
